import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.less'],
})
export class SearchBarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('searchRef') searchRef: ElementRef;
  public sub: Subscription;

  constructor(public router: Router, public route: ActivatedRoute) {}

  ngOnInit() {

  }


  ngAfterViewInit(): void {
    this.searchRef.nativeElement.value = this.route.snapshot.queryParams.search || '';

    this.sub = Observable.fromEvent(this.searchRef.nativeElement, 'keyup')
      // get value
      .map((evt: any) => evt.target.value)
      // text length must be > 2 chars
      //.filter(res => res.length > 2)
      // emit after 1s of silence
      .debounceTime(500)
      // emit only if data changes since the last emit
      .distinctUntilChanged()
      // subscription
      .subscribe((text: string) => this.router.navigate([], { relativeTo: this.route, queryParams: text ? {search: text} : {} }));
  }


  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe()
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/search-bar/search-bar.component.ts